import React from 'react';
import './Roadmap.css';

const Roadmap = () => {
  const phases = [
    {
      phase: 'Phase 1',
      title: 'Launch',
      status: 'completed',
      items: [
        'Token deployment on Ethereum',
        'Website launch',
        'Social media presence',
        'Community building',
        'Initial marketing push'
      ]
    },
    {
      phase: 'Phase 2',
      title: 'Growth',
      status: 'current',
      items: [
        'CoinGecko & CMC listings',
        'Influencer partnerships',
        '1,000+ holders milestone',
        'Trending on DEXTools',
        'Meme competition launch'
      ]
    },
    {
      phase: 'Phase 3',
      title: 'Expansion',
      status: 'upcoming',
      items: [
        'CEX listings',
        'Gold-themed NFT collection',
        'Strategic partnerships',
        '10,000+ holders',
        'Major exchange listings'
      ]
    },
    {
      phase: 'Phase 4',
      title: 'Domination',
      status: 'upcoming',
      items: [
        'Tier 1 CEX listings',
        '$GOLD merchandise store',
        'Global marketing campaign',
        'Gold standard of meme coins',
        'Moon 🌕'
      ]
    }
  ];

  return (
    <section className="roadmap" id="roadmap">
      <div className="container">
        <h2 className="section-title">
          <span className="gold-text">Roadmap</span>
        </h2>

        <div className="roadmap-container">
          <div className="roadmap-line"></div>
          {phases.map((phase, index) => (
            <div className={`roadmap-phase ${phase.status}`} key={index}>
              <div className="phase-marker">
                {phase.status === 'completed' ? '✓' : phase.status === 'current' ? '→' : '○'}
              </div>
              <div className="phase-content">
                <span className="phase-label">{phase.phase}</span>
                <h3 className="phase-title">{phase.title}</h3>
                <ul className="phase-items">
                  {phase.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
